'use client'
import { eAreaType } from '@/app/models/enum/areaType';
import Facility from './Facility';
import { iAreaSimpelModel } from '@/app/models/apiModels/areaSimpel';
import { iImagePicker } from '@/app/models/blockTypes/imagePicker';
import { useEffect, useState } from 'react';
import Accordion from '../Accordion/Accordion';
import Loader from '../Loader/Loader';
import { SCREEN_BREAKPOINTS } from '@/app/helpers/constants';

interface Props {
    model: iAreaSimpelModel;
    showAreaName?: boolean;
    translations: any;
    defaultFacilityImage?: iImagePicker[];
    currentAreaType?: eAreaType;
}


export default function Area({ model, showAreaName, translations, defaultFacilityImage, currentAreaType }: Props) {
    const showCity = currentAreaType === eAreaType.Country || currentAreaType === eAreaType.Region;
    const doShowAreaName = showAreaName;
    const hideArea = model.areaType === eAreaType.District && model.facilities.length === 0;
    const [isDesktop, setIsDesktop] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const updateScreenSize = () => {
            setIsDesktop(window.innerWidth > SCREEN_BREAKPOINTS.DESKTOP && currentAreaType === eAreaType.Country || currentAreaType === eAreaType.Region);
        }

        updateScreenSize();
        window.addEventListener("resize", updateScreenSize);
        return () => window.removeEventListener("resize", updateScreenSize);
    }, [])

    useEffect(() => {
        setIsLoading(false);
    }, [isDesktop]);

    const onToggleCallback = (isExpanding: boolean) => {
        setIsExpanded(isExpanding);
    }

    return (
        <>
            {isLoading && (
                <div className="flex justify-center lg:col-span-2 p-2">
                    <Loader
                        loading={isLoading}
                        useFullWindow={false}
                        useNoBackground={true}
                    />
                </div>
            )}
            {!hideArea && !isLoading && (
                <>
                    {doShowAreaName && model.areaType === eAreaType.Region ? (
                        <Accordion
                            title={model.name}
                            translations={translations}
                            isExpandedOnLoad={isDesktop}
                            className={`lg:col-span-2 border border-gs-black rounded-[16px]`}
                            onExpandCallback={onToggleCallback}
                        >
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 pt-1">
                                {model.facilities && model.facilities.map((facility) => (
                                    <Facility key={facility.id} model={facility} showCity={showCity} isInGrid={true} translations={translations} defaultFacilityImage={defaultFacilityImage} />
                                ))}
                                {model.subAreas && model.subAreas.map((subArea) => (
                                    <Area key={subArea.id} model={subArea} showAreaName={showAreaName} translations={translations} defaultFacilityImage={defaultFacilityImage} currentAreaType={currentAreaType} />
                                ))}
                            </div>
                        </Accordion>
                    ) : (
                        <>
                            {doShowAreaName && model.areaType === eAreaType.City && (
                                <h3 className="lg:col-span-2 text-xl text-center mb-0-i font-bold">
                                    <a href={model.path} title={model.name} className="area-heading no-underline hover:underline">
                                        {model.name}
                                    </a>
                                </h3>
                            )}
                            {model.facilities && model.facilities.map((facility) => (
                                <Facility key={facility.id} model={facility} showCity={showCity} isInGrid={true} translations={translations} defaultFacilityImage={defaultFacilityImage} />
                            ))}
                            {model.subAreas && model.subAreas.map((subArea) => (
                                <Area key={subArea.id} model={subArea} showAreaName={showAreaName} translations={translations} defaultFacilityImage={defaultFacilityImage} currentAreaType={currentAreaType} />
                            ))}
                        </>
                    )}
                </>
            )}
        </>
    );
}